// extracted by mini-css-extract-plugin
export default {"main":"Szukaj_main__oienc","icon_szukaj":"Szukaj_icon_szukaj__NXmGp","icon_clear":"Szukaj_icon_clear__8y50d","szukajInput":"Szukaj_szukajInput__GrYBJ","icon2":"Szukaj_icon2__O3G+W"};